module.exports = __webpack_public_path__ + "44c2f0e9fca2b319f5033c63b4e413b8.png";